import React from "react";
import {
  Box,
  Flex,
  SimpleGrid,
  Skeleton,
  SkeletonText,
  HStack,
} from "@chakra-ui/react";

export const SelectAudienceSkeleton = () => {
  return (
    <Box p={8} bg="gray.50" minH="100vh">
      {/* Step Info */}
      <Flex justify="space-between" mb={6}>
        <Skeleton height="20px" width="200px" />
        <Skeleton height="20px" width="80px" />
      </Flex>

      {/* Page Title */}
      <Skeleton height="28px" width="260px" mb={2} />
      <Skeleton height="16px" width="340px" mb={8} />

      {/* Four Cards */}
      <SimpleGrid columns={{ base: 1, md: 2 }} spacing={6}>
        {Array(4)
          .fill("")
          .map((_, i) => (
            <Box
              key={i}
              p={6}
              borderWidth="1px"
              borderRadius="xl"
              bg="white"
              shadow="sm"
            >
              <HStack spacing={4} mb={4}>
                <Skeleton boxSize="40px" borderRadius="md" />
                <Skeleton height="20px" width="120px" />
              </HStack>

              <SkeletonText noOfLines={2} spacing="3" mb={4} />

              <HStack spacing={3}>
                {Array(3)
                  .fill("")
                  .map((_, j) => (
                    <Skeleton key={j} height="24px" width="80px" borderRadius="md" />
                  ))}
              </HStack>
            </Box>
          ))}
      </SimpleGrid>

      {/* Continue Button */}
      <Flex justify="flex-end" mt={8}>
        <Skeleton height="40px" width="120px" borderRadius="md" />
      </Flex>
    </Box>
  );
};
